import React, { useState, useEffect } from "react";

// Modules

// App
import { client, entitiesEnabled, apiEndpoints, serverUrl } from "../../config";
import { getOnlineNode } from "../../core/getNode";
import { postNode } from "../../core/postNode";
import { deleteRequest } from "../../core/delete";
import { buildReactions } from "../../utils/helpers";
import FavouriteBtn from "../favouriteBtn";
import ShareBtn from "../shareBtn";

// Ui
import {
  IconButton,
  Typography,
  CircularProgress,
  SvgIcon,
  Button,
} from "@mui/material";
import { Row, Col } from "react-bootstrap";
import Like from "@mui/icons-material/ThumbUpOutlined";
import LikeActive from "@mui/icons-material/ThumbUp";
import Heart from "@mui/icons-material/FavoriteBorderOutlined";
import HeartActive from "@mui/icons-material/FavoriteOutlined";
import Happy from "@mui/icons-material/EmojiEmotionsOutlined";
import HappyActive from "@mui/icons-material/EmojiEmotions";

export default function Reactions(props) {
  const [isLoading, setLoading] = useState(true);
  const [reactions, setReactions] = useState({});
  const [reactionOptions, setReactionOptions] = useState([]);

  // The Drupal entity type the vote is stored against. Custom entities (news,
  // event, podcast, …) must use their own type; legacy node content (blogs,
  // v2 clients) falls back to "node".
  const reactionEntityType = props.entityType || "node";

  // Entities return a boolean `true`; legacy node APIs return the string "true".
  const allowReactions =
    props.field_allow_reactions === "true" ||
    props.field_allow_reactions === true;

  useEffect(() => {
    switch (client) {
      case "equans":
        setReactionOptions([
          {
            type: "reaction_like",
            counterKey: "likes",
            class: "like",
            icon: (
              <SvgIcon color="commentLike">
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 417 417"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    strokeLinejoin: "round",
                    strokeMiterLimit: 2,
                  }}
                >
                  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
                    <g transform="matrix(1,0,0,1,0,-952.362)">
                      <path
                        d="M40.698,969.161C40.282,980.128 38.982,986.552 32.604,996.036C31.519,994.982 30.052,994.317 28.448,994.317L12.424,994.317C9.152,994.317 6.424,997.045 6.424,1000.32L6.424,1036.32C6.424,1039.59 9.152,1042.32 12.424,1042.32L28.448,1042.32C30.131,1042.32 31.662,1041.59 32.76,1040.44C33.542,1041.06 34.271,1041.63 35.104,1042.13C36.874,1043.19 38.937,1043.83 41.573,1044.1C46.844,1044.64 55.148,1044.24 74.448,1044.32C75.137,1044.32 75.823,1044.07 76.354,1043.63C80.173,1040.52 82.048,1037.31 82.917,1033.91C83.25,1033.73 83.549,1033.48 83.792,1033.19C86.687,1029.57 87.855,1025.4 87.354,1021.63C87.514,1021.5 87.661,1021.35 87.792,1021.19C91.15,1017 92.214,1012.03 91.01,1007.85C92.98,1005.29 93.83,1002.29 93.51,999.505C93.118,996.087 90.931,993.007 87.635,991.567C87.262,991.404 86.855,991.319 86.448,991.317L61.823,991.317C63.14,981.477 62.135,972.456 58.667,966.348C56.701,962.888 53.702,960.86 50.698,960.411C45.301,959.748 41.215,963.54 40.698,969.161ZM53.448,969.317C56.18,974.129 57.458,983.593 55.51,993.755C55.181,995.48 56.692,997.312 58.448,997.317L85.573,997.317C86.693,997.944 87.393,998.904 87.542,1000.19C87.68,1001.4 87.158,1002.86 85.948,1004.32L77.424,1004.32C75.839,1004.32 74.381,1005.73 74.381,1007.32C74.381,1008.9 75.839,1010.34 77.424,1010.32L85.385,1010.32C85.613,1012.01 85.194,1014.15 83.823,1016.32L75.424,1016.32C73.839,1016.32 72.381,1017.73 72.381,1019.32C72.381,1020.9 73.839,1022.34 75.424,1022.32L81.385,1022.32C81.613,1024.02 81.194,1026.15 79.823,1028.32L73.424,1028.32C71.839,1028.32 70.381,1029.73 70.381,1031.32C70.381,1032.9 71.839,1034.34 73.424,1034.32L76.479,1034.32C75.864,1035.64 74.889,1036.81 73.167,1038.32C54.958,1038.26 46.28,1038.56 42.167,1038.13C40.048,1037.91 39.212,1037.6 38.167,1036.97C37.297,1036.45 36.096,1035.46 34.448,1034.13L34.448,1003.72C43.832,991.177 46.199,982.402 46.698,969.442C47.635,964.276 52.113,966.419 53.448,969.317ZM12.424,1000.32L28.448,1000.32C28.38,1012.24 28.448,1024.31 28.448,1036.32L12.424,1036.32L12.424,1000.32Z"
                        style={{ fill: "currentColor", fillRule: "nonzero" }}
                      />
                    </g>
                  </g>
                </svg>
              </SvgIcon>
            ),
            iconReacted: (
              <SvgIcon color="commentLike">
                <svg style={{ fill: "currentColor" }} viewBox="0 0 21.3 20.56">
                  <path
                    d="M22.62,11.29A2.57,2.57,0,0,0,21.1,9.22a.91.91,0,0,0-.37-.08H15.06a10,10,0,0,0-.82-5.89,2.91,2.91,0,0,0-2.06-1.52l-.31,0A2.36,2.36,0,0,0,9.56,4a10.31,10.31,0,0,1-1.78,6.15,1.66,1.66,0,0,0-1-.31H3A1.66,1.66,0,0,0,1.34,11.5v8.63A1.65,1.65,0,0,0,3,21.77H6.82a1.62,1.62,0,0,0,1-.39,2.83,2.83,0,0,0,.45.32,3.92,3.92,0,0,0,1.63.5,20.5,20.5,0,0,0,2.08.07h5.82a1,1,0,0,0,.59-.21,4.42,4.42,0,0,0,1.61-2.36.92.92,0,0,0,.2-.17,3.87,3.87,0,0,0,.91-2.83l.05-.05A3.83,3.83,0,0,0,22,13.35,2.93,2.93,0,0,0,22.62,11.29Zm-1.57,5.22-.1.1a3.66,3.66,0,0,1-.86,2.77.74.74,0,0,1-.21.18,4.26,4.26,0,0,1-1.57,2.33.76.76,0,0,1-.46.16c-4.63,0-6.62.08-7.88-.05a3.78,3.78,0,0,1-1.55-.47,4.46,4.46,0,0,1-.56-.41,1.43,1.43,0,0,1-1,.45H3a1.45,1.45,0,0,1-1.44-1.44V11.5A1.45,1.45,0,0,1,3,10.06H6.82a1.44,1.44,0,0,1,1,.41A10.51,10.51,0,0,0,9.76,4a2.13,2.13,0,0,1,2.4-2.1,2.72,2.72,0,0,1,1.91,1.42,9.93,9.93,0,0,1,.76,6h5.9A.72.72,0,0,1,21,9.4a2.38,2.38,0,0,1,1.4,1.91,2.75,2.75,0,0,1-.6,2A3.57,3.57,0,0,1,21.05,16.51Z"
                    transform="translate(-1.34 -1.71)"
                  />
                  <path
                    d="M6.82,11.5c0,2.86,0,5.75,0,8.63H3V11.5Z"
                    transform="translate(-1.34 -1.71)"
                  />
                  <path
                    d="M17.84,13.18a.75.75,0,0,0,.73.72h1.91a2.23,2.23,0,0,1-.38,1.44h-2a.72.72,0,1,0,0,1.44h1.43a2.25,2.25,0,0,1-.38,1.44H17.61a.72.72,0,1,0,0,1.43h.73a2.93,2.93,0,0,1-.79,1c-4.37,0-6.45.06-7.44,0a2,2,0,0,1-1-.28c-.21-.13-.49-.36-.89-.68V12.32A12.83,12.83,0,0,0,11.2,4.1c.22-1.24,1.3-.73,1.62,0a9.44,9.44,0,0,1,.49,5.86.75.75,0,0,0,.71.85h6.5a.86.86,0,0,1,.47.69,1.34,1.34,0,0,1-.38,1h-2A.75.75,0,0,0,17.84,13.18Z"
                    transform="translate(-1.34 -1.71)"
                  />
                </svg>
              </SvgIcon>
            ),
          },
          {
            type: "reaction_thanks",
            counterKey: "thanks",
            class: "thanks",
            icon: (
              <SvgIcon color="commentLove">
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 417 417"
                  version="1.1"
                  style={{
                    fill: "currentColor",
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    strokeLineJoin: "round",
                    strokeMiterLimit: 2,
                  }}
                >
                  <g transform="matrix(4.16667,0,0,4.16667,0,0)">
                    <g transform="matrix(1.14456,0,0,1.14456,0.241461,-21.1455)">
                      <path
                        d="M77.325,54.795L80.027,52.094C82.577,49.646 82.768,45.577 80.459,42.9C79.581,41.912 78.421,41.217 77.136,40.908L77.683,40.361C80.241,37.915 80.433,33.839 78.116,31.164C76.922,29.823 75.223,29.036 73.428,28.992C71.632,28.957 69.895,29.645 68.609,30.9L68.308,31.202C67.153,30.104 65.632,29.47 64.039,29.423C62.248,29.39 60.517,30.08 59.241,31.338L56.13,34.448C55.427,31.518 52.787,29.433 49.773,29.427L49.764,29.427C48.035,29.425 46.375,30.114 45.156,31.341L33.281,43.216C33.059,41.293 32.158,39.511 30.741,38.192C28.822,36.46 25.841,36.543 24.022,38.38L12.772,49.63C2.549,59.552 1.937,75.982 11.392,86.638C17.788,93.754 27.591,96.825 36.905,94.631C38.09,94.792 39.285,94.875 40.481,94.878C47.465,94.882 54.168,92.09 59.084,87.13L80.225,66.005C82.768,63.547 82.957,59.48 80.653,56.797C79.775,55.805 78.613,55.106 77.325,54.795ZM78.136,44.988C79.318,46.444 79.181,48.59 77.823,49.884L70.891,56.817C70.845,56.773 70.795,56.739 70.75,56.698C70.639,56.6 70.527,56.505 70.411,56.416C70.295,56.327 70.136,56.216 69.994,56.122C69.881,56.048 69.769,55.966 69.652,55.905C69.483,55.809 69.308,55.728 69.133,55.648C69.031,55.602 68.934,55.55 68.831,55.509C68.547,55.395 68.255,55.302 67.958,55.231L70.117,53.07L70.659,52.531C70.935,52.25 71.187,51.945 71.413,51.622C71.508,51.489 71.587,51.35 71.672,51.212C71.775,51.041 71.873,50.869 71.962,50.691C72.052,50.512 72.156,50.287 72.237,50.08C72.266,50.003 72.287,49.923 72.314,49.852C72.615,48.993 72.74,48.082 72.681,47.173L72.681,47.159C72.66,46.864 72.62,46.571 72.559,46.281C72.547,46.219 72.53,46.156 72.516,46.094C72.48,45.937 72.455,45.781 72.408,45.642L73.214,44.836C73.868,44.18 74.765,43.825 75.691,43.855C76.627,43.877 77.513,44.288 78.136,44.988ZM70.819,33.113C71.489,32.449 72.401,32.088 73.344,32.114C74.283,32.139 75.172,32.553 75.795,33.256C76.98,34.712 76.838,36.862 75.473,38.15L71,42.622L70.969,42.655L70.692,42.933C70.653,42.897 70.611,42.867 70.573,42.833C70.448,42.722 70.323,42.614 70.192,42.52C70.061,42.427 69.947,42.344 69.822,42.261C69.697,42.178 69.57,42.091 69.437,42.016C69.305,41.941 69.125,41.859 68.969,41.788C68.85,41.731 68.734,41.67 68.612,41.622C68.339,41.513 68.058,41.424 67.772,41.353L67.755,41.353L68.303,40.806C68.596,40.507 68.862,40.183 69.097,39.836C69.138,39.778 69.173,39.72 69.211,39.661C69.391,39.385 69.552,39.097 69.691,38.798C69.73,38.716 69.772,38.642 69.808,38.553C69.952,38.212 70.069,37.86 70.156,37.5C70.184,37.386 70.197,37.27 70.219,37.156C70.265,36.913 70.3,36.668 70.322,36.422C70.334,36.266 70.341,36.109 70.342,35.942C70.342,35.727 70.331,35.513 70.313,35.297C70.298,35.141 70.292,34.984 70.269,34.841C70.218,34.517 70.144,34.198 70.045,33.886L70.819,33.113ZM20.539,89.722C17.961,88.428 15.644,86.668 13.706,84.531C5.371,75.1 5.939,60.587 14.986,51.836L26.236,40.586C26.574,40.246 27.034,40.054 27.514,40.052C27.918,40.046 28.31,40.195 28.608,40.469C29.633,41.429 30.216,42.773 30.216,44.178C30.216,45.525 29.68,46.818 28.728,47.77L18.148,58.344C17.844,58.638 17.671,59.044 17.671,59.468C17.671,60.325 18.377,61.03 19.234,61.03C19.658,61.03 20.064,60.858 20.358,60.553L30.927,49.986L47.363,33.55C47.999,32.909 48.866,32.55 49.769,32.552C51.645,32.553 53.189,34.097 53.189,35.973C53.189,36.88 52.828,37.751 52.188,38.392L34.588,55.995C34.283,56.29 34.11,56.696 34.11,57.119C34.11,57.976 34.816,58.682 35.673,58.682C36.097,58.682 36.503,58.509 36.797,58.205L54.398,40.602L61.455,33.547C62.096,32.906 62.966,32.546 63.872,32.546C64.844,32.546 65.77,32.96 66.419,33.683C66.851,34.17 67.124,34.778 67.2,35.425C67.2,35.467 67.2,35.512 67.208,35.556C67.224,35.721 67.228,35.886 67.22,36.052C67.22,36.109 67.209,36.167 67.205,36.225C67.19,36.383 67.165,36.539 67.131,36.694C67.119,36.75 67.105,36.806 67.089,36.863C67.043,37.028 66.987,37.19 66.92,37.348C66.905,37.387 66.889,37.427 66.872,37.464C66.679,37.881 66.415,38.26 66.091,38.584L62.464,42.211L61.611,43.063L61.602,43.073L61.602,43.081L41.633,63.041C41.328,63.335 41.156,63.741 41.156,64.165C41.156,65.022 41.861,65.727 42.718,65.727C43.142,65.727 43.548,65.555 43.842,65.25L63.803,45.289C63.867,45.225 63.941,45.18 64.008,45.122C64.627,44.602 65.407,44.31 66.216,44.295L66.309,44.295C66.542,44.301 66.773,44.331 67,44.383C67.682,44.544 68.299,44.912 68.764,45.436C69.117,45.836 69.362,46.32 69.473,46.842C69.745,48.103 69.354,49.419 68.439,50.328L68.127,50.641L61.787,56.964C61.773,56.978 61.77,56.995 61.756,57.009L48.677,70.089C48.372,70.383 48.2,70.789 48.2,71.213C48.2,72.07 48.905,72.775 49.762,72.775C50.186,72.775 50.592,72.603 50.886,72.298L64.011,59.183C64.492,58.7 65.108,58.373 65.778,58.245L65.823,58.233C66.052,58.192 66.285,58.175 66.517,58.183C66.727,58.19 66.937,58.217 67.142,58.263L67.208,58.272C67.288,58.291 67.364,58.327 67.438,58.35C68.027,58.53 68.557,58.867 68.97,59.323C69.117,59.487 69.247,59.665 69.356,59.856C70.104,61.305 69.813,63.084 68.642,64.219L47.5,85.35C47.07,85.78 46.627,86.188 46.172,86.578C46.088,86.648 46.002,86.714 45.917,86.784C45.555,87.086 45.188,87.377 44.811,87.655C44.664,87.763 44.513,87.866 44.364,87.967C44.042,88.192 43.716,88.409 43.386,88.617C43.205,88.731 43.023,88.841 42.839,88.95C42.527,89.13 42.223,89.302 41.909,89.469C41.703,89.578 41.495,89.688 41.284,89.791C40.994,89.934 40.698,90.067 40.402,90.197C40.166,90.302 39.933,90.409 39.689,90.509C39.445,90.609 39.183,90.697 38.93,90.789C38.636,90.895 38.345,91.006 38.048,91.102C37.991,91.12 37.931,91.134 37.873,91.152C37.417,91.292 36.956,91.422 36.491,91.534C36.477,91.534 36.466,91.548 36.45,91.553C31.098,92.842 25.459,92.193 20.539,89.722ZM56.875,84.916C53.642,88.174 49.511,90.398 45.011,91.303C45.105,91.244 45.189,91.17 45.283,91.109C45.786,90.786 46.27,90.43 46.755,90.069C47.036,89.861 47.327,89.667 47.598,89.444C48.181,88.975 48.739,88.463 49.287,87.936C49.425,87.806 49.577,87.694 49.709,87.561L70.85,66.42C71.132,66.131 71.388,65.817 71.616,65.483C71.694,65.372 71.759,65.258 71.831,65.144C71.955,64.946 72.068,64.742 72.17,64.533C72.258,64.355 72.339,64.178 72.411,63.995C72.456,63.878 72.492,63.758 72.531,63.637C72.801,62.833 72.916,61.985 72.872,61.138L72.872,60.997C72.853,60.731 72.817,60.466 72.764,60.205C72.744,60.1 72.716,59.998 72.691,59.892C72.666,59.786 72.639,59.636 72.6,59.512L73.37,58.741C74.012,58.095 74.885,57.731 75.795,57.731C76.765,57.731 77.691,58.145 78.339,58.867C79.518,60.333 79.377,62.483 78.017,63.783L56.875,84.916Z"
                        style={{ fillRule: "nonzero" }}
                      />
                    </g>
                  </g>
                </svg>
              </SvgIcon>
            ),
            iconReacted: (
              <SvgIcon color="commentLove">
                <svg viewBox="0 0 19.57 16.49" style={{ fill: "currentColor" }}>
                  <path
                    d="M12.66,18.75l-.3.24a.57.57,0,0,1-.13.08,1.51,1.51,0,0,1-.26.18l-.15.09-.26.15-.17.08-.24.12-.2.08-.21.08-.24.08-.05,0-.38.1h0a6.39,6.39,0,0,1-6.24-1.93,6.52,6.52,0,0,1,.35-9L7.26,6.07a.51.51,0,0,1,.35-.15.42.42,0,0,1,.3.12,1.39,1.39,0,0,1,.44,1,1.41,1.41,0,0,1-.41,1L5,10.94a.46.46,0,0,0-.13.31.43.43,0,0,0,.43.43.48.48,0,0,0,.31-.13l7.41-7.41a.91.91,0,0,1,.66-.28.94.94,0,0,1,.66,1.61L9.55,10.3a.44.44,0,0,0-.13.31.43.43,0,0,0,.43.43.41.41,0,0,0,.31-.14L15,6.07l1.94-1.93a.91.91,0,0,1,.66-.28,1,1,0,0,1,.7.31.87.87,0,0,1,.21.48v0a.57.57,0,0,1,0,.13.07.07,0,0,1,0,0,.51.51,0,0,1,0,.13.09.09,0,0,1,0,0l0,.13,0,0a1,1,0,0,1-.21.31l-1,1L17,6.75l-5.48,5.48a.41.41,0,0,0-.14.31.43.43,0,0,0,.43.43.44.44,0,0,0,.31-.13l5.48-5.48.06-.05a.94.94,0,0,1,.6-.22h0l.19,0a1,1,0,0,1,.48.29.81.81,0,0,1,.2.39,1.05,1.05,0,0,1-.29,1l-.08.09L17,10.56v0l-3.59,3.59a.4.4,0,0,0-.13.31.42.42,0,0,0,.43.42.39.39,0,0,0,.3-.13l3.61-3.6a.89.89,0,0,1,.48-.25h.21l.17,0h0l.07,0a1,1,0,0,1,.42.27,1.3,1.3,0,0,1,.1.15,1,1,0,0,1-.19,1.2l-5.8,5.8c-.12.11-.24.23-.37.33Z"
                    transform="translate(-2.2 -3.74)"
                  />
                  <path
                    d="M18.89,6.35l-.23-.07.15-.15A1.39,1.39,0,0,0,19,5.86l0,0c.05-.08.1-.16.14-.24l0-.07a1.4,1.4,0,0,0,.09-.29.29.29,0,0,0,0-.09l0-.2a.66.66,0,0,1,0-.14s0-.11,0-.17,0-.09,0-.13a1.22,1.22,0,0,0-.06-.26L19.5,4a1,1,0,0,1,.69-.28.91.91,0,0,1,.67.32,1,1,0,0,1-.09,1.34L19.55,6.63h0l-.08.07,0,0-.11-.09-.1-.07-.1-.07L19,6.4Z"
                    transform="translate(-2.2 -3.74)"
                  />
                  <path
                    d="M20.83,7a.9.9,0,0,1,.67.31,1,1,0,0,1-.08,1.34l-1.9,1.9,0,0-.1-.08-.11-.08-.09-.06L19,10.2l-.08,0-.24-.07.59-.59.15-.15a1.64,1.64,0,0,0,.21-.25L19.73,9a1.09,1.09,0,0,0,.08-.15l.08-.17a.14.14,0,0,1,0-.06,2,2,0,0,0,.1-.73h0a2,2,0,0,0,0-.24.11.11,0,0,0,0,0s0-.09,0-.12l.22-.22A.92.92,0,0,1,20.83,7Z"
                    transform="translate(-2.2 -3.74)"
                  />
                  <path
                    d="M21.47,12.44l-5.8,5.8A6.39,6.39,0,0,1,12.41,20l.08,0c.14-.09.27-.19.4-.29l.23-.17.47-.41L13.7,19l5.8-5.8a1.71,1.71,0,0,0,.21-.26.47.47,0,0,0,.06-.09,1,1,0,0,0,.1-.17l.06-.15a.36.36,0,0,0,0-.09,2,2,0,0,0,.09-.69v0l0-.22s0,0,0-.08a.61.61,0,0,0,0-.11l.22-.21a.91.91,0,0,1,.66-.28.94.94,0,0,1,.7.32A1,1,0,0,1,21.47,12.44Z"
                    transform="translate(-2.2 -3.74)"
                  />
                </svg>
              </SvgIcon>
            ),
          },
          {
            type: "reaction_insightful",
            counterKey: "insightful",
            class: "insightful",
            icon: (
              <SvgIcon color="commentLaugh">
                <svg viewBox="0 0 20.53 22.78" style={{ fill: "currentColor" }}>
                  <path
                    d="M12.28,4.6A6.28,6.28,0,0,0,7.05,14.75a9.67,9.67,0,0,1,1.63,2.9l0,.07v2.52a.66.66,0,0,0,.55.65,2.74,2.74,0,0,0,5.46,0,.64.64,0,0,0,.56-.64v-2.5l0-.07a9.56,9.56,0,0,1,1.63-2.88,6.13,6.13,0,0,0,1.34-4.15A6.36,6.36,0,0,0,12.28,4.6ZM14,18v1.58H10V18Zm-2,4.07a1.44,1.44,0,0,1-1.41-1.2h2.83A1.42,1.42,0,0,1,12,22.06Zm3.89-8.13a11.43,11.43,0,0,0-1.64,2.74H9.74a12.35,12.35,0,0,0-1.63-2.74,4.87,4.87,0,0,1-1.06-3.07A5,5,0,0,1,8.59,7.27,4.88,4.88,0,0,1,12.25,5.9,5,5,0,0,1,17,10.62,5.12,5.12,0,0,1,15.88,13.93Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M12,3.12a.65.65,0,0,0,.65-.65V1.25a.65.65,0,0,0-1.3,0V2.47A.65.65,0,0,0,12,3.12Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M7.22,3.93a.66.66,0,0,0,1.15-.64l-.6-1.06a.65.65,0,1,0-1.13.65Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M5,6.09,4,5.49a.65.65,0,1,0-.65,1.13l1.06.6a.7.7,0,0,0,.33.09A.65.65,0,0,0,5,6.09Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M4.24,10.86a.63.63,0,0,0-.64-.64H2.37a.63.63,0,0,0-.64.64.64.64,0,0,0,.64.65H3.6A.63.63,0,0,0,4.24,10.86Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M4.39,14.51l-1.06.6a.65.65,0,0,0-.24.89.66.66,0,0,0,.58.33A.59.59,0,0,0,4,16.24l1.06-.6a.65.65,0,0,0,.24-.89A.67.67,0,0,0,4.39,14.51Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M20.65,15.11l-1.06-.6a.65.65,0,0,0-.65,1.13l1.06.6a1,1,0,0,0,.34.09.68.68,0,0,0,.57-.33A.69.69,0,0,0,20.65,15.11Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M21.61,10.22H20.38a.63.63,0,0,0-.64.64.64.64,0,0,0,.64.65h1.23a.64.64,0,0,0,.64-.65A.63.63,0,0,0,21.61,10.22Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M19.26,7.31a.59.59,0,0,0,.33-.09l1.06-.6A.65.65,0,1,0,20,5.49l-1.06.6a.64.64,0,0,0-.23.89A.57.57,0,0,0,19.26,7.31Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M15.85,4.17a.79.79,0,0,0,.34.1.67.67,0,0,0,.57-.34l.6-1.05A.64.64,0,0,0,17.12,2a.63.63,0,0,0-.88.24l-.6,1.06A.62.62,0,0,0,15.85,4.17Z"
                    transform="translate(-1.73 -0.6)"
                  />
                </svg>
              </SvgIcon>
            ),
            iconReacted: (
              <SvgIcon color="commentLaugh">
                <svg viewBox="0 0 20.53 22.78" style={{ fill: "currentColor" }}>
                  <path
                    d="M12.28,4.6A6.28,6.28,0,0,0,7.05,14.75a9.67,9.67,0,0,1,1.63,2.9l0,.07v2.52a.66.66,0,0,0,.55.65,2.74,2.74,0,0,0,5.46,0,.64.64,0,0,0,.56-.64v-2.5l0-.07a9.56,9.56,0,0,1,1.63-2.88,6.13,6.13,0,0,0,1.34-4.15A6.36,6.36,0,0,0,12.28,4.6ZM14,18v1.58H10V18Zm-2,4.07a1.44,1.44,0,0,1-1.41-1.2h2.83A1.42,1.42,0,0,1,12,22.06Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M12,3.12a.65.65,0,0,0,.65-.65V1.25a.65.65,0,0,0-1.3,0V2.47A.65.65,0,0,0,12,3.12Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M7.22,3.93a.66.66,0,0,0,1.15-.64l-.6-1.06a.65.65,0,1,0-1.13.65Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M5,6.09,4,5.49a.65.65,0,1,0-.65,1.13l1.06.6a.7.7,0,0,0,.33.09A.65.65,0,0,0,5,6.09Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M4.24,10.86a.63.63,0,0,0-.64-.64H2.37a.63.63,0,0,0-.64.64.64.64,0,0,0,.64.65H3.6A.63.63,0,0,0,4.24,10.86Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M4.39,14.51l-1.06.6a.65.65,0,0,0-.24.89.66.66,0,0,0,.58.33A.59.59,0,0,0,4,16.24l1.06-.6a.65.65,0,0,0,.24-.89A.67.67,0,0,0,4.39,14.51Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M20.65,15.11l-1.06-.6a.65.65,0,0,0-.65,1.13l1.06.6a1,1,0,0,0,.34.09.68.68,0,0,0,.57-.33A.69.69,0,0,0,20.65,15.11Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M21.61,10.22H20.38a.63.63,0,0,0-.64.64.64.64,0,0,0,.64.65h1.23a.64.64,0,0,0,.64-.65A.63.63,0,0,0,21.61,10.22Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M19.26,7.31a.59.59,0,0,0,.33-.09l1.06-.6A.65.65,0,1,0,20,5.49l-1.06.6a.64.64,0,0,0-.23.89A.57.57,0,0,0,19.26,7.31Z"
                    transform="translate(-1.73 -0.6)"
                  />
                  <path
                    d="M15.85,4.17a.79.79,0,0,0,.34.1.67.67,0,0,0,.57-.34l.6-1.05A.64.64,0,0,0,17.12,2a.63.63,0,0,0-.88.24l-.6,1.06A.62.62,0,0,0,15.85,4.17Z"
                    transform="translate(-1.73 -0.6)"
                  />
                </svg>
              </SvgIcon>
            ),
          },
        ]);
        break;

      case "companyapp":
        setReactionOptions([
          {
            label: "Like",
            type: "reaction_like",
            class: "like",
            icon: <Like color="commentLike" />,
            iconReacted: <LikeActive color="commentLike" />,
          },
        ]);
        break;

      default:
        setReactionOptions([
          {
            type: "reaction_like",
            class: "like",
            icon: <Like color="commentLike" />,
            iconReacted: <LikeActive color="commentLike" />,
          },
          {
            type: "reaction_love",
            icon: <Heart color="commentLove" />,
            iconReacted: <HeartActive color="commentLove" />,
          },
          {
            type: "reaction_laughing",
            icon: <Happy color="commentLaugh" />,
            iconReacted: <HappyActive color="commentLaugh" />,
          },
        ]);
        break;
    }

    getReactions();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {}, [reactions]);

  const getReactions = () => {
    if (props.nid && allowReactions) {
      setLoading(true);
      const path = entitiesEnabled
        ? `api/v3/reactions/${reactionEntityType}/${props.nid}`
        : `${apiEndpoints.reactions}/${props.nid}`;

      getOnlineNode(path, props.user.access_token)
        .then((response) => {
          setReactions(buildReactions(response.data, props.user));
          setLoading(false);
        })
        .catch((_error) => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  const addReaction = (type) => {
    setLoading(true);

    if (!entitiesEnabled) {
      // Legacy node clients: post to votingapi's core entity/vote resource.
      const data = {
        _links: {
          type: {
            href: `${serverUrl}/rest/type/vote/${type}`,
          },
        },
        entity_id: [{ target_id: props.nid }],
        entity_type: [{ value: "node" }],
      };

      postNode("entity/vote", data, props.user.csrf_token)
        .then(() => {
          getReactions();
        })
        .catch((_error) => {
          setLoading(false);
        });
      return;
    }

    // Post to our entity-aware endpoint, which records the vote server-side.
    // votingapi's core entity/vote resource hardcodes a node-only reference
    // check that rejects votes on custom entities.
    postNode(
      `api/v3/reactions/${reactionEntityType}/${props.nid}`,
      { type },
      props.user.csrf_token
    )
      .then((response) => {
        getReactions();
      })
      .catch((_error) => {
        setLoading(false);
      });
  };

  const removeReaction = () => {
    if (reactions.reactionId) {
      setLoading(true);
      deleteRequest(
        `entity/vote/${reactions.reactionId}?_format=json`,
        props.user.csrf_token,
        props.user.access_token
      )
        .then((response) => {
          getReactions();
        })
        .catch((_error) => {
          setLoading(false);
        });
    }
  };

  const reactionTypeCounterMap = (type) => {
    const typeObj = {
      reaction_like: "likes",
      reaction_love: "love",
      reaction_laughing: "surprised",
      reaction_thanks: "thanks",
      reaction_insightful: "insightful",
    };
    return typeObj[type];
  };

  return (
    <Row
      className="reactions-container gx-0 d-flex justify-content-center align-items-center"
      style={{ position: "relative" }}
    >
      <div
        className={`${
          !isLoading && "invisible"
        } w-100 d-flex justify-content-center align-items-center`}
      >
        <CircularProgress size={24} />
      </div>
      {!props.disableReactions && allowReactions && (
          <>
            {reactionOptions.map((option, index) => {
              return (
                <Col
                  key={`reaction-${index}`}
                  xs={'auto'}
                  className={`reaction ${isLoading ? "invisible" : ""} me-4`}
                >
                  <Row className="d-flex align-items-center gx-0 pe-2">
                    <Col xs={"auto"}>
                      {option.label ? (
                        <Button
                          className={`reaction-btn ${option.class}`}
                          disabled={
                            isLoading ||
                            (reactions.hasReacted &&
                              reactions.reactionType !== option.type)
                          }
                          onClick={() => {
                            if (reactions.hasReacted) {
                              removeReaction();
                            } else {
                              addReaction(option.type);
                            }
                          }}
                          endIcon={
                            reactions.reactionType === option.type
                              ? option.iconReacted
                              : option.icon
                          }
                        >
                          {option.label}
                        </Button>
                      ) : (
                        <IconButton
                          className={`reaction-btn ${option.class}`}
                          disabled={
                            isLoading ||
                            (reactions.hasReacted &&
                              reactions.reactionType !== option.type)
                          }
                          onClick={() => {
                            if (reactions.hasReacted) {
                              removeReaction();
                            } else {
                              addReaction(option.type);
                            }
                          }}
                        >
                          {reactions.reactionType === option.type
                            ? option.iconReacted
                            : option.icon}
                        </IconButton>
                      )}
                    </Col>
                    <Col xs={"auto"} className="ms-3">
                      <Typography className="reaction-count">
                        {reactions[reactionTypeCounterMap(option.type)]}
                      </Typography>
                    </Col>
                  </Row>
                </Col>
              );
            })}
          </>
        )}
      <Col xs={'auto'} className={`reaction`}>
        <FavouriteBtn
          enableLabel
          id={props.nid || props.id}
          className={"singles-favorite reaction-btn"}
          contentType={props.contentType}
          title={props.title}
          thumbnail={props.thumbnail}
        />
      </Col>
      {(window.location.pathname.split("/")[1] === "blogs" ||
        (props.shareEnabled && props.field_access_token)) && (
        <Col xs={'auto'} className={`reaction ms-4`}>
          <ShareBtn
            id={props.nid || props.id}
            title={props.title}
            route={window.location.pathname.split("/")[1]}
            field_access_token={props.field_access_token}
            sharePrompt={props?.sharePrompt}
            enableLabel
          />
        </Col>
      )}
    </Row>
  );
}
